import request from './axiosAPI'

// 登入相關 API，由 auth store 呼叫
export function loginApi(payload) {
  return request.post('/api/Auth/Login', payload)
}

// 驗證 Token
export function verifyApi() {
  return request.get('/api/Auth/Verify')
}

export function changePasswordApi(payload) {
  return request.post('/api/Auth/ChangePassword', payload)
}

// 「換發 token」和「清除 token」
export function refreshApi(payload) {
  return request.post('/api/Auth/Refresh', payload)
}